import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

// 出勤時の申告の設定(その店舗に当てはまる設定の読み取り)。設定の変更は admin/CheckInSettings
export default {
  // userId と date を付けると、そのキャストがその営業日にすでに申告した「1営業日に1回まで」の項目も返る
  getCheckInSettings({ userId = null, date = null, exceptTimecardId = null } = {}) {
    return axiosIns.get('/waiter/check_in_settings', {
      params: snakecaseKeys({ userId, date, exceptTimecardId }),
    })
  },

  // 保存せずに出勤時刻を計算する。
  //   timecardId あり: そのタイムカードの申告を変えた場合 / なし: これから打刻する場合
  calculate({ punchedAt = null, timecardId = null, declarationItemIds = [] }) {
    return axiosIns.post('/waiter/check_in_settings/calculate', snakecaseKeys({
      punchedAt,
      timecardId,
      declarationItemIds,
    }))
  },
}
